export * from './settings.component';
